export const REF_POPULATION_TOTAL = 'totalPopulation';
export const REF_POPULATION_LABOUR = 'labourForce';

export const BEN_UNIT_HOUSEHOLDS = 'h';
export const BEN_UNIT_INDIVIDUALS = 'i';